/**
 * Post condition type selector with support fot multiple conditions selections.
 */
export default function (currentSelections) {
    return {
        currentSelections: currentSelections || [],
        select: function (type) {
            if (this.currentSelections.includes(type)) {
                this.currentSelections = this.currentSelections.filter((selection) => {
                    return selection != type;
                });
            } else {
                this.currentSelections.push(type);
            }
        },
    };
}
